export enum Flipper {
  storefront = 'rt_storefront',
  navigationCollections = 'rt_retailer_collections_navigation_v2',
}
